import Vue from 'vue'
import router from 'router'
import interfaces from 'api/api'
import { setUid, getUid, setParams, removeUser, removeParams, setSigParams, setToken, setIsSystem, removeToken, setCode, removeCode, getCode } from 'utils/auth'
import { getUrlParam, isWeixin } from 'utils/index'
import { CODE_OK } from 'utils/publicData'
Vue.prototype.$api = interfaces
const wx = require('weixin-js-sdk');

router.beforeEach((to, from, next) => {
  if(to.meta.title)
  document.title = to.meta.title
  // if (isWeixin()) { // 判断是否是微信环境
  //   // 微信环境
  //   wx.miniProgram.getEnv((res) => {
  //     if (window.__wxjs_environment === 'miniprogram') { // 小程序环境下逻辑
  //       console.log('小程序环境')
  //       next()
  //     } else { // 微信环境
  //     }
  //   })
  // } else {
  //   console.log('WEB环境')
  //   next()
  // }
  next()
})
// router.afterEach(async (to) => {
//   let baseLocation = "https://xkjcapp.xiekang.net" //自行改为项目地址
//   if (window.__wxjs_is_wkwebview) { // 通过此属性判断IOS
//     if (window.entryUrl == '' || window.entryUrl == undefined) {
//       var url = baseLocation + encodeURIComponent(to.fullPath)
//       window.entryUrl = url
//       console.log("IOS  to.fullPath")
//       console.log(to.fullPath)
//       console.log("IOS  entryUrl")
//       console.log(window.entryUrl)
//     }
//   } else { // 安卓
//     window.entryUrl = baseLocation + to.fullPath
//     console.log("window.entryUrl")
//     console.log(window.entryUrl)
//   }
//   localStorage.setItem("url", window.entryUrl) //直接在使用页面 用来请求接口配置config
// })
